import React from 'react';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';

const ProductPriceNormal = styled('p')`
  margin: 0;
  font-size: 14px;
`;

const ProductPriceDiscount = styled('p')`
  margin: 0;
  font-size: 14px;
  color: red;
`;

const ProductPricePrevious = styled('p')`
  margin: 0;
  font-size: 12px;
  text-decoration: line-through;
`;

export const ProductPrice = ({ price, discount }) => {
  return (
    <>
      {discount ? (
        <>
          <ProductPriceDiscount><b>{t('Pris')}:</b> {discount}:-</ProductPriceDiscount>
          <ProductPricePrevious>{price} kr</ProductPricePrevious>
        </>
      ) : (
        <ProductPriceNormal><b>{t('Pris')}:</b> {price}:-</ProductPriceNormal>
      )}
    </>
  );
}